var styles = {
  "wrapper": "ktl-cta-block-module_wrapper_U-RIE",
  "topTitle": "ktl-cta-block-module_top-title_ve70f",
  "mainTitle": "ktl-cta-block-module_main-title_JbxBG",
  "content": "ktl-cta-block-module_content_lCnnn",
  "buttons": "ktl-cta-block-module_buttons_ObAIt",
  "layout": "ktl-cta-block-module_layout_J-jWe"
};
export { styles as default };
